export function useUrlParams() {
  const params = new URLSearchParams(window.location.search)
  return {
    sessionId: params.get('session_id') || undefined,
    mode: params.get('mode') || undefined,
    transmission: params.get('transmission') || undefined,
    character: params.get('character') || undefined,
    story: params.get('story') || undefined,
    features: params.get('features') || undefined,
    // Per-session TTS fast-model switchover (ENG-945). Stays a string all the
    // way to the query param the server parses; '0' means never use the fast model.
    fastSentences: params.get('fast_sentences') || undefined,
  }
}
